import type { FC, PropsWithChildren } from 'react';
import { GoogleReCaptchaProvider as Provider } from '@wojtekmaj/react-recaptcha-v3';

export const GoogleReCaptchaProvider: FC<PropsWithChildren> = ({ children }) => {
  const { VITE_RECAPTCHA_SITE_KEY } = import.meta.env;

  return <Provider reCaptchaKey={VITE_RECAPTCHA_SITE_KEY}>{children}</Provider>;
};
